module.exports = __webpack_public_path__ + "static/media/Original Korean - Teaching - chowol.83d72f93.txt";